import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from '../axios-default';
import { SET_SUPPROTED_RETAINTER_TYPES } from '../store/DiffRetainers/actionType';
import useAuth from './useAuth';

const useSupportedRetainerTypes = (isFetchRetainerRelatedData = false) => {
    const dispatch = useDispatch();
    const auth = useAuth();

    useEffect(() => {
        if (auth.user && auth.user.user_id && isFetchRetainerRelatedData) {
            const getSupportedRetainerTypes = async () => {
                const res = await axios.get('retainerType');
                if (res.data && res.status === 200) {
                    dispatch({ type: SET_SUPPROTED_RETAINTER_TYPES, payload: res.data.retainerTypes });
                }
            };
            getSupportedRetainerTypes();
        }
    }, [auth.user, dispatch, isFetchRetainerRelatedData]);
};

export default useSupportedRetainerTypes;
